import { render, staticRenderFns } from "./LessonMessage.vue?vue&type=template&id=17566464&scoped=true"
import script from "./LessonMessage.vue?vue&type=script&lang=js"
export * from "./LessonMessage.vue?vue&type=script&lang=js"
import style0 from "./LessonMessage.vue?vue&type=style&index=0&id=17566464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17566464",
  null
  
)

export default component.exports